export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/toJSON.js
// module id = 760
// module chunks = 41